"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreScheduleIndicator = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const andes_react_1 = require("@yonderland/andes-react");
const dayjs_1 = tslib_1.__importDefault(require("dayjs"));
const utc_1 = tslib_1.__importDefault(require("dayjs/plugin/utc"));
const timezone_1 = tslib_1.__importDefault(require("dayjs/plugin/timezone"));
const react_i18next_1 = require("react-i18next");
const i18nConstants_1 = require("../../../constants/i18nConstants");
const GeneralConstants_1 = require("../../../constants/GeneralConstants");
const common_components_1 = require("@as-react/common-components");
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
const STORE_CLOSE_CUTOFF = 60;
const SEPARATOR = ' · ';
const StoreScheduleIndicator = ({ todaySchedule }) => {
    const { t } = (0, react_i18next_1.useTranslation)(i18nConstants_1.I18N_NAMESPACES.store);
    const { market } = (0, common_components_1.useAemConfig)();
    const todayDate = (0, dayjs_1.default)().tz(GeneralConstants_1.TIMEZONE_BY_MARKET[market]);
    const todayTimeInMinutes = todayDate.hour() * 60 + todayDate.minute();
    const currentlyOpened = !todaySchedule.closed &&
        todayTimeInMinutes >= todaySchedule.openTimeInMinutes &&
        todayTimeInMinutes < todaySchedule.closeTimeInMinutes;
    const openingLaterToday = !todaySchedule.closed && todayTimeInMinutes < todaySchedule.openTimeInMinutes;
    const closesSoon = currentlyOpened && todaySchedule.closeTimeInMinutes - todayTimeInMinutes <= STORE_CLOSE_CUTOFF;
    if (closesSoon) {
        return ((0, jsx_runtime_1.jsxs)(andes_react_1.TextAlpha, { variant: "bodyM", children: [(0, jsx_runtime_1.jsx)(andes_react_1.TextAlpha, { variant: "bodyM", color: "warning", as: "span", children: t('store.closes_soon') }), SEPARATOR, t('store.closes_soon_at', { closingHour: todaySchedule.closingHour })] }));
    }
    if (currentlyOpened) {
        return ((0, jsx_runtime_1.jsxs)(andes_react_1.TextAlpha, { variant: "bodyM", children: [(0, jsx_runtime_1.jsx)(andes_react_1.TextAlpha, { variant: "bodyM", color: "success", as: "span", children: t('store.open') }), SEPARATOR, t('store.closes_at', { closingHour: todaySchedule.closingHour })] }));
    }
    if (openingLaterToday) {
        return ((0, jsx_runtime_1.jsxs)(andes_react_1.TextAlpha, { variant: "bodyM", children: [(0, jsx_runtime_1.jsx)(andes_react_1.TextAlpha, { variant: "bodyM", color: "error", as: "span", children: t('store.closed.txt') }), SEPARATOR, t('store.opens_at', { openingHour: todaySchedule.openingHour })] }));
    }
    return ((0, jsx_runtime_1.jsx)(andes_react_1.TextAlpha, { variant: "bodyM", color: "error", as: "span", children: t('store.closed.txt') }));
};
exports.StoreScheduleIndicator = StoreScheduleIndicator;
